module.exports = __webpack_public_path__ + "img/icon-telefon_schwarz.a3d98708.svg";